import Struct, { placeholder } from "@yume-chan/struct";
import { ScrcpyControlMessageType } from "./type.js";
// https://cs.android.com/android/platform/superproject/+/master:frameworks/base/core/java/android/view/SurfaceControl.java;l=659;drc=20303e05bf73796124ab70a279cf849b61b97905
export var AndroidScreenPowerMode;
(function (AndroidScreenPowerMode) {
    AndroidScreenPowerMode[AndroidScreenPowerMode["Off"] = 0] = "Off";
    AndroidScreenPowerMode[AndroidScreenPowerMode["Normal"] = 2] = "Normal";
})(AndroidScreenPowerMode = AndroidScreenPowerMode || (AndroidScreenPowerMode = {}));
export const ScrcpySetScreenPowerModeControlMessage = new Struct()
    .uint8("type", ScrcpyControlMessageType.SetScreenPowerMode)
    .uint8("mode", placeholder());
//# sourceMappingURL=set-screen-power-mode.js.map